import React, { useEffect } from 'react';
import { JBTypography } from '@jbhi-fi/lanyard-ui';
import ReceiptLayout from '../receipt.layout';
import { useTracking, trackingContext } from '@jbhi-fi/components/src/Tracking';

const LockedOutView = () => {
  const { tracker } = useTracking({
    context: trackingContext.modal,
    group: 'too many attempts',
    category: 'eReceipts',
  });
  useEffect(() => {
    tracker.trackView();
  }, []);

  return (
    <ReceiptLayout ripped>
      <div className="primary-block">
        <JBTypography align="center" type="h5" margin="10px 0">
          Oops you've tried too many times...
        </JBTypography>
        <JBTypography align="left" type="p">
          Please try again in 24 hours using the link we sent you.
        </JBTypography>
      </div>
    </ReceiptLayout>
  );
};

export default LockedOutView;
